export function closeWebviewKik() {
  window.close();
  return Promise.resolve();
}

export function dotFlowCallbackKik(chatId, from, body) {
  return fetch(`${process.env.REACT_APP_DOTFLOW}/kikflow`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      chatId,
      from,
      body
    })
  });
}



// WEBPACK FOOTER //
// ./src/utils/kikWebview.js